import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';

import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'printingHotkeys Print Order Summary',
    defaultMessage: 'Print Order Summary',
    id: '440oJ7',
  },
});

export const hotkey = ['o', 's'];
export const barcodeContent = '+VA5RU8988R68=';

const PrintOrderSummaryHotkey = ({ children = null, handler }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['os'],
      barcode: barcodeContent,
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'printing',
      doNotTrack: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

PrintOrderSummaryHotkey.propTypes = {
  children: PropTypes.node,
  handler: PropTypes.func.isRequired,
};

export default PrintOrderSummaryHotkey;
